import React from 'react'
import {
    ReloadOutlined
} from "@ant-design/icons"
import {updateAnnualRates} from './ExchangeRateFuncs'
import {RefTable, DefaultProps, Validator} from "./RefTable";

export const AnnualExchangeRates = (props)=><RefTable {...props}/>;

AnnualExchangeRates.defaultProps = {
    ...DefaultProps,
    tableName: "annual_exchange_rates",
    tableSchema: "annual_exchange_rates",
    edit: true,
    title: "Annual Exchange Rates",
    theadHeight: 40,
    validator: {
        annual_rate: new Validator("annual_rate", async (value)=> {
            if(value <= 0 )
                return Promise.reject("Exchange rate cannot be zero or negative")
        })
    },
    actions: [
        {
            event: "sync",
            title: "Sync",
            icon: <ReloadOutlined/>
        }
    ],
    onEvent: async (e)=>{
        if(e === "sync")
            await updateAnnualRates()
    },
}
